@if (state) {
  <div class="container" pTooltip="{{ text | translate }}" tooltipPosition="right" escape>
    <div class="connection-status" [ngClass]="classMap[state]"></div>
    <ng-content></ng-content>
  </div>
}
